/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type shifts_AvailabilityWindowResponse = {
    end_time: string;
    kind: shifts_AvailabilityWindowResponse.kind;
    start_time: string;
};
export namespace shifts_AvailabilityWindowResponse {
    export enum kind {
        AVAILABLE = 'available',
        UNAVAILABLE = 'unavailable',
    }
}

